import { WEB_VERSION } from '../version';
import { NotFoundIcon } from '../assets/Icons';

function PageNotFound({ errorMessage }: { errorMessage?: string | undefined }) {
  return (
    <div className="w-full h-full p-5 flex flex-col justify-center items-center text-center">
      <div className="relative text-up-black-20">
        <NotFoundIcon />
        {!errorMessage && (
          <div className="text-5xl font-bold absolute bottom-0 left-0">404</div>
        )}
      </div>
      <p className="text-lg font-bold text-up-black-100 mt-12">
        {errorMessage ?? "Order Up ... wait, no—it's missing!"}
      </p>
      <p className="text-sm text-up-black-50 my-5">
        This page or order couldn't be found. Please check your URL or try again
        in sometime.
      </p>
      <p className="text-sm text-up-black-50 mb-10 font-bold">
        v {WEB_VERSION}
      </p>
    </div>
  );
}

export default PageNotFound;
